// src/hooks/useHomePage.js

import {
    useEffect,
    useState
} from "react";

import {
    updateLocation,
    handlePageHide,
    fetchAttendance,
    getProfileLocation
} from "../functions/TrackingEmployeeFunctions";

import {
    useNavigate
} from "react-router-dom";


const useTrackingEmployee = () => {

    const navigate = useNavigate();


    // =========================================================
    // STATES
    // =========================================================

    const [checkedOut, setCheckedOut] =
        useState(false);

    const [attendance, setAttendance] =
        useState([]);

    const [range, setRange] =
        useState("today");

    const [fromDate, setFromDate] =
        useState("");

    const [toDate, setToDate] =
        useState("");

    const [loginTime, setLoginTime] =
        useState(null);

    const [workingTime, setWorkingTime] =
        useState("00:00:00");

  const [distancef, setDistancef] = useState("Calculating distance...");


    // =========================================================
    // EMPLOYEE DATA
    // =========================================================

    const empauth =
        localStorage.getItem("empuser");


    const empuser =
        JSON.parse(
            localStorage.getItem("empuser") || "null"
        );


    const empid =
        empuser?._id;


    const compid =
        empuser?.compid;


    const token =
        localStorage.getItem("emptoken");



    // =========================================================
    // EFFECT 1
    // GET LOCATION IMMEDIATELY
    // UPDATE EVERY 1 MINUTE
    // =========================================================

    useEffect(() => {

        // Immediately
        updateLocation();


        // Every 1 minute
        const interval =
            setInterval(
                updateLocation,
                10000
            );


        return () => {

            clearInterval(interval);

        };

    }, []);



    // =========================================================
    // EFFECT 2
    // TAB CLOSE / PAGE HIDE
    // =========================================================

    useEffect(() => {

        const pageHideHandler = () => {

            handlePageHide(
                navigate
            );

        };


        window.addEventListener(
            "pagehide",
            pageHideHandler
        );


        return () => {

            window.removeEventListener(
                "pagehide",
                pageHideHandler
            );

        };

    }, [navigate]);



    // =========================================================
    // FETCH ATTENDANCE FUNCTION
    // =========================================================

   const loadAttendance = async () => {

    try {

        console.log("=================================");
        console.log("FETCHING ATTENDANCE");
        console.log("Employee ID:", empid);
        console.log("Company ID:", compid);
        console.log("Token:", token);
        console.log("Range:", range);
        console.log("=================================");


        const data = await fetchAttendance({

            empid,
            compid,
            token,
            range,
            fromDate,
            toDate

        });


        console.log("=================================");
        console.log("ATTENDANCE API RESULT:");
        console.log(data);
        console.log("=================================");


        setAttendance(
            Array.isArray(data)
                ? data
                : []
        );


    } catch (error) {

        console.error(
            "ATTENDANCE FETCH ERROR:",
            error
        );

        setAttendance([]);

    }
};



    // =========================================================
    // EFFECT 3
    // TODAY / MONTH ATTENDANCE
    // =========================================================

  useEffect(() => {

    if (
        token &&
        empid &&
        compid &&
        range !== "custom"
    ) {

        loadAttendance();

    }

}, [
    token,
    empid,
    compid,
    range
]);



    // =========================================================
    // EFFECT 4
    // WORKING TIME TIMER
    // =========================================================

    useEffect(() => {

        if (
            !attendance ||
            attendance.length === 0
        ) {

            setWorkingTime(
                "00:00:00"
            );

            return;
        }


        const todayAttendance =
            attendance[0];


        const sessions =
            todayAttendance.sessions || [];

            console.log("=================================");
console.log("ATTENDANCE DATA:", attendance);
console.log("TODAY ATTENDANCE:", todayAttendance);
console.log("SESSIONS:", sessions);
console.log("=================================");


        // =====================================================
        // ACTIVE SESSION
        // =====================================================

        const activeSession =
            sessions.find(
                session =>
                    !session.checkOut
            );


        if (activeSession?.checkIn) {

            setLoginTime(
                activeSession.checkIn
            );

        }



        // =====================================================
        // CALCULATE WORKING TIME
        // =====================================================

        const calculateWorkingTime = () => {

            let totalMilliseconds = 0;


            sessions.forEach(
                (session) => {

                    if (!session.checkIn) {
                        return;
                    }


                    const checkIn =
                        new Date(
                            session.checkIn
                        );


                    // Completed session
                    if (session.checkOut) {

                        const checkOut =
                            new Date(
                                session.checkOut
                            );


                        totalMilliseconds +=
                            checkOut.getTime()
                            -
                            checkIn.getTime();

                    }


                    // Current session
                    else {

                        const now =
                            new Date();


                        totalMilliseconds +=
                            now.getTime()
                            -
                            checkIn.getTime();
                    }

                }
            );



            // =================================================
            // CONVERT TO HH:MM:SS
            // =================================================

            const totalSeconds =
                Math.floor(
                    totalMilliseconds / 1000
                );


            const hours =
                Math.floor(
                    totalSeconds / 3600
                );


            const minutes =
                Math.floor(
                    (totalSeconds % 3600) / 60
                );


            const seconds =
                totalSeconds % 60;



            setWorkingTime(

                `${String(hours).padStart(2, "0")}:` +

                `${String(minutes).padStart(2, "0")}:` +

                `${String(seconds).padStart(2, "0")}`

            );
        };



        // Immediately calculate
        calculateWorkingTime();


        // Every second
        const timer =
            setInterval(
                calculateWorkingTime,
                1000
            );


        return () => {

            clearInterval(timer);

        };

    }, [attendance]);



    // =========================================================
    // EFFECT 5
    // DISTANCE CHECK
    // =========================================================


useEffect(() => {

    let mounted = true;

    const employeeData = JSON.parse(
        localStorage.getItem("empuser") || "null"
    );

    const restrictLocation =
        employeeData?.restrictLocation === true;


    const updateLocationAndDistance = () => {

        navigator.geolocation.getCurrentPosition(

            async (position) => {

                const location = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    recordedAt: new Date().toISOString()
                };

                // Save latest location
                localStorage.setItem(
                    "lastLocation",
                    JSON.stringify(location)
                );


                // Get company location and distance
                const locationData =
                    await getProfileLocation();


                if (!mounted) {
                    return;
                }


                if (locationData) {

                    const distance =
                        Math.round(
                            locationData.distanceMeters
                        );


                    // ALWAYS SHOW DISTANCE
                    setDistancef(
                        `Final Distance: ${distance} meters`
                    );


                    console.log(
                        "Distance:",
                        distance,
                        "meters"
                    );


                    // AUTO CHECKOUT ONLY WHEN
                    // restrictLocation IS TRUE
                    if (
                        restrictLocation &&
                        distance > 100
                    ) {

                        console.log(
                            "Employee is outside 100 meter radius"
                        );

                        handlePageHide(
                            navigate
                        );
                    }

                } else {

                    setDistancef(
                        "Distance unavailable"
                    );
                }
            },

            (error) => {

                console.log(
                    "Location error:",
                    error
                );

                if (mounted) {

                    setDistancef(
                        "Location unavailable"
                    );
                }
            },

            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };


    // Run immediately
    updateLocationAndDistance();


    // Run every 1 minute
    const interval = setInterval(
        updateLocationAndDistance,
        60000
    );


    return () => {

        mounted = false;

        clearInterval(interval);

    };


}, [navigate]);


    // =========================================================
    // RETURN EVERYTHING TO Tracking Page
    // =========================================================

    return {

        empauth,

        checkedOut,
        setCheckedOut,

        attendance,
        setAttendance,

        range,
        setRange,

        fromDate,
        setFromDate,

        toDate,
        setToDate,

        loginTime,

        workingTime,

        distancef

    };

};


export default useTrackingEmployee;